<div (click)="verifyMenu()">
  <a [routerLink]="[url]" class="menu-item-link" routerLinkActive="active">
    <mat-list-item>
      <div class="active-border"></div>
      <mat-icon
        aria-hidden="false"
        aria-label="dashboard"
        class="menu-item-icon"
        class="{{ class }}"
        svgIcon="{{ icon }}"
      ></mat-icon>
      <span class="menu-name">{{ title }}</span>
      <span class="new">{{ new }}</span>
      <!-- <span *ngIf="key == 'dashboard'" class="beta">beta</span> -->
    </mat-list-item>
  </a>
</div>
